import { Tag } from '@design-system/components/tag/tag';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
import {
  faCircle,
  faStar as faStarSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { Tooltip } from '@mui/material';
import { clsx } from 'clsx';
import { PpcPriceModal } from '../pages/collections/components/ppcPriceModal';

export const PpcTag = ({
  enabled,
  requested,
  showTag,
  priceModal,
  price,
}: {
  enabled: boolean;
  requested: boolean;
  showTag: boolean;
  priceModal: {
    close: () => void;
    open: () => void;
    isOpen: boolean;
  };
  price: {
    monthly?: number;
    annual?: number;
  };
}) => {
  if (!showTag) return null;

  return (
    <>
      <Tooltip
        placement="right"
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: 'black',
              color: 'white',
              fontSize: '12px',
              fontWeight: 500,
              fontFamily: 'inherit',
              padding: '4px 8px',
            },
          },
        }}
        title={
          requested ? (
            <div className="flex flex-col gap-4">
              <Typography variant="body" size="small">
                You requested to offer an Exclusive Subscription and are pending
                approval.
              </Typography>
              <Typography variant="body" size="small">
                If you sent a request less than 48 hours ago, please wait for a
                response. If it has been longer, please email our support team
                at creatorsupport@playbookapp.io
              </Typography>
            </div>
          ) : enabled ? (
            <Typography>
              You're offering an exclusive subscription.{' '}
              <Typography
                className={clsx(sprinkles({ color: 'P-60' }), 'cursor-pointer')}
                onClick={priceModal.open}
              >
                Click here to learn more
              </Typography>
            </Typography>
          ) : undefined
        }
      >
        <div>
          <Tag
            endIcon={enabled ? faStarSolid : faStar}
            startIcon={requested ? faCircle : undefined}
            startIconClassName={clsx(requested && 'text-[#FFD03B]')}
            className="ml-8 bg-white"
            onClick={priceModal.open}
          />
        </div>
      </Tooltip>
      <PpcPriceModal
        isOpen={priceModal.isOpen}
        close={priceModal.close}
        price={price}
        enabled={enabled}
        requested={requested}
      />
    </>
  );
};
